import React from "react";
import { useParams } from "react-router-dom";
import PlaceholderPage from "./PlaceholderPage";

// One route → 6 pages: About, Editorial, Ethics, Contact, Privacy, Disclaimer.
// Content is copy-only placeholder; edit strings below to publish live text.
const CONTENT = {
  about: {
    eyebrow: "Masthead",
    title: "About Vexent Wire",
    body: (
      <>
        <p>
          Vexent Wire publishes independent research, market strategy, and
          editorial commentary in a single chronological feed. The mission is
          durable: give thoughtful readers institutional-grade analysis without
          institutional bias or paywall gatekeeping on breaking material.
        </p>
        <p>
          Founded in 2001. Editorially independent. No investor-relations
          affiliation, no advisory clients on the coverage list, no sponsored
          research disguised as opinion.
        </p>
        <p className="text-[13px] text-neutral-600">
          Full masthead, editorial history, and organizational statement pending.
        </p>
      </>
    ),
  },
  editorial: {
    eyebrow: "Masthead",
    title: "Editorial Policy",
    body: (
      <>
        <p>
          Every piece published on Vexent Wire is written by, or reviewed
          by, a named human editor. AI is used for research support and audio
          narration only — never for byline text.
        </p>
        <p>
          Corrections are made in place with a dated correction note appended
          to the piece. Retractions are announced on the homepage.
        </p>
        <p className="text-[13px] text-neutral-600">
          Full editorial charter to be published.
        </p>
      </>
    ),
  },
  ethics: {
    eyebrow: "Masthead",
    title: "Ethics & Disclosure",
    body: (
      <>
        <p>
          Contributors disclose all material positions in publicly traded
          securities, commodities, digital assets, and private funds before
          publishing anything that references those instruments.
        </p>
        <p>
          Vexent Wire accepts no payment for coverage. Any sponsored
          content is clearly labeled and separated from editorial pages.
        </p>
        <p className="text-[13px] text-neutral-600">
          Full disclosure framework in preparation.
        </p>
      </>
    ),
  },
  contact: {
    eyebrow: "Masthead",
    title: "Contact",
    body: (
      <>
        <p>
          Story tips, corrections, and press inquiries are welcome. The
          preferred channel is email. Confidential tips can be sent via the
          same address with the subject line prefixed <em>SECURE:</em>.
        </p>
        <ul className="pt-2 space-y-1 font-mono-tick text-[14px]">
          <li>Editorial &nbsp;· editorial@vexentnews.com</li>
          <li>Tips &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;· tips@vexentnews.com</li>
          <li>Press &nbsp;&nbsp;&nbsp;&nbsp;· press@vexentnews.com</li>
        </ul>
        <p className="text-[13px] text-neutral-600 pt-3">
          Direct-message and encrypted-messaging channels will be added.
        </p>
      </>
    ),
  },
  privacy: {
    eyebrow: "Masthead",
    title: "Privacy",
    body: (
      <>
        <p>
          Vexent Wire collects the minimum data required to run the site:
          an anonymous visit count, article page-view counts, and audio play
          counts. No user tracking cookies, no ad networks, no third-party
          analytics without explicit consent.
        </p>
        <p>
          Email subscribers are stored only to deliver the Insider brief. You
          can unsubscribe at any time and your record is permanently deleted.
        </p>
        <p className="text-[13px] text-neutral-600">
          Full privacy statement in preparation.
        </p>
      </>
    ),
  },
  disclaimer: {
    eyebrow: "Masthead",
    title: "Disclaimer",
    body: (
      <>
        <p>
          Nothing published on Vexent Wire constitutes investment, legal,
          tax, or accounting advice. All content is intended for informational
          and educational purposes only.
        </p>
        <p>
          Markets carry risk. Past performance does not indicate future
          results. Readers are solely responsible for their financial and
          investment decisions.
        </p>
        <p className="text-[13px] text-neutral-600">
          Full legal disclaimer to be finalized with counsel.
        </p>
      </>
    ),
  },
};

export const MastheadPage = () => {
  const { section } = useParams();
  const key = (section || "about").toLowerCase();
  const c = CONTENT[key] || CONTENT.about;
  return (
    <PlaceholderPage
      eyebrow={c.eyebrow}
      title={c.title}
      body={c.body}
      testid={`masthead-${key}`}
    />
  );
};

export default MastheadPage;
